import { EProductMatchType } from "@inbound/api";

export const EMatchType: Record<string, string | undefined> = {
  [EProductMatchType.AutoMatch]: "Auto match",
  [EProductMatchType.AutoMatchFailed]: "Auto match fail",
};
